import React from "react";



export function XBEconfWeb({
  handleFilter,
  checkIfShow,
}) {
  return <div className="l_block l_block--hide-34 noselect">
    <div className="l_block_bg" />
    <div className="l_content">
      <div className="l_content_center">
        <div className="l_block_bg l_block_bg--xbe--grad" />
        <div className="l_width_1160">
          <div className="l_paddings_l">
            <div className="l_paddings_m_bot">
              <div className="l_line">
                <div className=""
                style={{
                  fontFamily: 'Sharp Grotesk 20, Arial, sans-serif',
                  color: '#f6faff',
                  fontSize: '1.6em',
                  lineHeight: '1.4em',
                }}>
                  <strong>
                    To get started, select the details below that best describe your game.
                </strong>
                  <br />
                </div>
              </div>
            </div>
            <div className="x_cat0">


              <div className="x_cat_col">

                <div className="x_cat_decal0"><div className="x_cat_decal_inner"><div className="x_cat_decal_h"><div>Stage</div></div><div className="x_cat_decal" /></div></div>


                <div className="l_line_li">
                  <div className="x_cat_sel0">


                    <div onClick={() => { handleFilter('all'); }} className={`x_cat_item x_cat_item_or x_cat_item--all ${checkIfShow('all') ? 'x_cat_item--active' : ''}`}>
                      <div className="x_sol_cardsul x_sol_cardsul--active">
                        <div className="x_cat_type_h">All stages</div>
                      </div>
                    </div>

                    <div onClick={() => { handleFilter('pre_launch'); }} className={`x_cat_item x_cat_item_or x_cat_item_next ${checkIfShow('pre_launch') ? 'x_cat_item--active' : ''}`}>
                      <div className="l_line_li">
                        <div className="x_cat_type_h">Pre-launch</div>
                      </div>

                      <div className="x_cat_item_active" />

                    </div>

                    <div onClick={() => { handleFilter('early_access'); }} className={`x_cat_item x_cat_item_or x_cat_item_next ${checkIfShow('early_access') ? 'x_cat_item--active' : ''}`}>
                      <div className="l_line_li">
                        <div className="x_cat_type_h">Early access</div>
                      </div>
                      <div className="x_cat_item_active" />
                    </div>

                    <div onClick={() => { handleFilter('live_game'); }} className={`x_cat_item x_cat_item_or ${checkIfShow('live_game') ? 'x_cat_item--active' : ''}`}>
                      <div className="l_line_li">
                        <div className="x_cat_type_h">Live game</div>
                      </div>
                    </div>


                  </div>
                </div>
              </div>



              <div className="x_cat_col">

                <div className="x_cat_decal0"><div className="x_cat_decal_inner"><div className="x_cat_decal_h"><div>Monetization</div></div><div className="x_cat_decal" /></div></div>

                <div className="l_line_li">
                  <div className="x_cat_sel0">

                    <div onClick={() => { handleFilter('premium'); }} className={`x_cat_item ${checkIfShow('premium') ? 'x_cat_item--active' : ''}`}>
                      <div className="l_line_li">
                        <div className="x_sol_cardsul x_sol_cardsul--active">
                          <div className="x_cat_type_h">Premium</div>
                        </div>
                      </div>
                      <div className="x_cat_item_active">
                        <div className="x_cat_item_check w-embed">
                          <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 11.6616L11.1319 16.9994L20.1841 7.52245" stroke="#FFF" />
                          </svg>
                        </div>
                      </div>
                    </div>


                    <div onClick={() => { handleFilter('microtransactions'); }} className={`x_cat_item ${checkIfShow('microtransactions') ? 'x_cat_item--active' : ''}`}>
                      <div className="l_line_li">
                        <div className="x_sol_cardsul x_sol_cardsul--active">
                          <div className="x_cat_type_h x_sol_cardsul--active">
                            Microtransactions
                        </div>
                        </div>
                      </div>
                      <div className="x_cat_item_active">
                        <div className="x_cat_item_check w-embed">
                          <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 11.6616L11.1319 16.9994L20.1841 7.52245" stroke="#FFF" />
                          </svg>
                        </div>
                      </div>
                    </div>


                    <div onClick={() => { handleFilter('subscriptions'); }} className={`x_cat_item ${checkIfShow('subscriptions') ? 'x_cat_item--active' : ''}`}>
                      <div className="l_line_li">
                        <div className="x_cat_type_h">Subscriptions</div>
                      </div>
                      <div className="x_cat_item_active">
                        <div className="x_cat_item_check w-embed">
                          <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 11.6616L11.1319 16.9994L20.1841 7.52245" stroke="#FFF" />
                          </svg>
                        </div>
                      </div>
                    </div>


                  </div>
                </div>
              </div>


              <div className="x_cat_col">

                <div className="x_cat_decal0"><div className="x_cat_decal_inner"><div className="x_cat_decal_h"><div>Platform</div></div><div className="x_cat_decal" /></div></div>
                <div className="l_line_li">
                  <div className="x_cat_sel0">



                    <div onClick={() => { handleFilter('pc_mac'); }} className={`x_cat_item ${checkIfShow('pc_mac') ? 'x_cat_item--active' : ''}`}>
                      <div className="l_line_li l_line--xs">
                        <div className="x_sol_cardsul x_sol_cardsul--active">
                          <div className="x_cat_type_h">PC/Mac</div>
                        </div>
                      </div>
                      <div className="x_cat_item_active">
                        <div className="x_cat_item_check w-embed">
                          <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 11.6616L11.1319 16.9994L20.1841 7.52245" stroke="#FFF" />
                          </svg>
                        </div>
                      </div>
                    </div>



                    <div onClick={() => { handleFilter('web'); }} className={`x_cat_item ${checkIfShow('web') ? 'x_cat_item--active' : ''}`}>
                      <div className="l_line_li l_line--xs">
                        <div className="x_sol_cardsul x_sol_cardsul--active">
                          <div className="x_cat_type_h">Web</div>
                        </div>
                      </div>
                      <div className="x_cat_item_active">
                        <div className="x_cat_item_check w-embed">
                          <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 11.6616L11.1319 16.9994L20.1841 7.52245" stroke="#FFF" />
                          </svg>
                        </div>
                      </div>
                    </div>


                    <div onClick={() => { handleFilter('mobile'); }} className={`x_cat_item ${checkIfShow('mobile') ? 'x_cat_item--active' : ''}`}>
                      <div className="l_line_li l_line--xs">
                        <div className="x_sol_cardsul x_sol_cardsul--active">
                          <div className="x_cat_type_h">Mobile</div>
                        </div>
                      </div>
                      <div className="x_cat_item_active">
                        <div className="x_cat_item_check w-embed">
                          <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 11.6616L11.1319 16.9994L20.1841 7.52245" stroke="#FFF" />
                          </svg>
                        </div>
                      </div>
                    </div>


                    <div onClick={() => { handleFilter('console'); }} className={`x_cat_item ${checkIfShow('console') ? 'x_cat_item--active' : ''}`}>
                      <div className="l_line_li l_line--xs">
                        <div className="x_sol_cardsul x_sol_cardsul--active">
                          <div className="x_cat_type_h">Console</div>
                        </div>
                      </div>
                      <div className="x_cat_item_active">
                        <div className="x_cat_item_check w-embed">
                          <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 11.6616L11.1319 16.9994L20.1841 7.52245" stroke="#FFF" />
                          </svg>
                        </div>
                      </div>
                    </div>


                  </div>
                </div>
              </div>



            </div>
          </div>

          <div className="l_paddings_m_bot">
            <div>
              <div className="t_corner_right-top t_corner_right-top--white" />

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>;
}
